module.exports = "<div class=\"image\">\r\n  <img [src]=\"sfcontrol.value\" alt=\"\">\r\n</div>\r\n"